import { configureStore } from '@reduxjs/toolkit';
import productsReducer from './slices/productsSlice';
import categoriesReducer from './slices/categoriesSlice';
import salesReducer from './slices/salesSlice';
import customersReducer from './slices/customersSlice';
import employeesReducer from './slices/employeesSlice';
import stockMovementsReducer from './slices/stockMovementsSlice';
import cashMovementsReducer from './slices/cashMovementsSlice';
import authReducer from './slices/authSlice';

export const store = configureStore({
  reducer: {
    products: productsReducer,
    categories: categoriesReducer,
    sales: salesReducer,
    customers: customersReducer,
    employees: employeesReducer,
    stockMovements: stockMovementsReducer,
    cashMovements: cashMovementsReducer,
    auth: authReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;